import { connect } from 'react-redux'
import React, { Component } from 'react'
import {
    setConformPage,
} from '../../action/action'
import { conformationColorSet } from '../../JS/setColors'
import { changePage } from "../../action/hcommerce"


class ConformPage extends Component {
    componentDidMount() {
        conformationColorSet(this.props.menuColor);
    }
    onYesClick = () => {
        this.props.setConformPage(false, null);
        if (this.props.compName === "FoodInfo") {
            this.props.changePage("ItemPage");
        }
        // this.props.roomSelectorStatus(false);
    }
    onNoClick = () => {
        this.props.setConformPage(false, null);
    }
    render() {
        return (
            <div className="overlay">
                <div id="svc" className="overlay-body">
                    <div className="primary-response center" style={{ color: "inherit" }}>
                        <div className="wide" style={{ fontSize: '20px', color: "inherit" }}>
                            {this.props.conformMessage}
                        </div>
                        <button className="btn-yes" onClick={() => { this.onYesClick() }} style={{ border: "none" }}>
                            {this.props.stringConst.yes}
                        </button>
                        <button className="btn-no" onClick={() => { this.onNoClick() }} style={{ border: "none" }}>
                            {this.props.stringConst.no}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        stringConst: state.store.home.stringConst,
        menuColor: state.store.home.MenuColor,
        conformMessage: state.store.conformMessage,
        compName: state.store.compName
    }
}
export default connect(
    mapStateToProps,
    {
        setConformPage,
        changePage
    }
)(ConformPage);